import React from "react";
import FormValueFieldPreview from "../form-value-field-preview/FormValueFieldPreview";
import FormLabelFieldPreview from "../form-label-field-preview/FormLabelFieldPreview";

const CommitmentsGridPreview = props => {
  const {commitments, findings, responsible} = props;

  const getFinding = idFinding => {
    const finding = findings.find(
      f => String(f.HallazgoId) === String(idFinding)
    );
    return finding?.Observacion || "";
  };

  const getUser = id => {
    const user = responsible.find(u => String(u.value) === String(id));
    return user?.label;
  };

  return (
    <div className="table-responsive-sm">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">
              <FormLabelFieldPreview label="Id" />
            </th>
            <th>
              <FormLabelFieldPreview label="Hallazgo" />
            </th>
            <th>
              <FormLabelFieldPreview label="Compromiso" />
            </th>
            <th>
              <FormLabelFieldPreview label="Responsable" />
            </th>
            <th>
              <FormLabelFieldPreview label="Email EE.SS" className="text-nowrap" />
            </th>
            <th>
              <FormLabelFieldPreview label="Requiere" />
            </th>
            <th>
              <FormLabelFieldPreview
                label="Fecha control"
                className="text-nowrap"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {commitments.map(item => (
            <tr key={item.idCompromiso}>
              <th scope="row">
                <FormValueFieldPreview value={item.idCompromiso} />
              </th>
              <td>
                <FormValueFieldPreview value={getFinding(item.HallazgoId)} />
              </td>
              <td>
                <FormValueFieldPreview value={item.Compromiso} />
              </td>
              <td>
                <FormValueFieldPreview
                  value={getUser(item.Responsable)}
                  className="text-nowrap"
                />
              </td>
              <td>
                <FormValueFieldPreview value={item.eess} />
              </td>
              <td>
                <FormValueFieldPreview value={item.Requiere ? "Si" : "No"} />
              </td>
              <td>
                <FormValueFieldPreview value={item.FechaControl} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CommitmentsGridPreview;
